import styled from 'styled-components';
import { breakpoints } from '../../../../../styles/theme';
import { StockModelCardDealerInfoStyled } from '../StockModelCardDealerInfoStyled';
import { rem } from 'polished';

export const StockModelCardDealerInfoStyledAC = styled(StockModelCardDealerInfoStyled)`
    .date-icon {
        margin-right: 0.4rem;
    }

    .dealer-location {
        &--icon {
            svg {
                height: ${rem('44px')};
                width: ${rem('28px')};
                margin: ${rem('-10px')} ${rem('10px')} 0 ${rem('3px')};
                path {
                    fill: ${({ theme }) => theme.colors.black} !important;
                }
            }
        }
        &--info {
            color: ${({ theme }) => theme.colors.grey5};
        }
        &--address {
            font-size: ${rem('14px')};
        }
    }
`;
